// extracted by mini-css-extract-plugin
module.exports = {"totalBox":"Total_totalBox__1lYwU","title":"Total_title__1rAfb","points":"Total_points__1BsOo"};